import React, { useRef, useState } from "react"
import { ChevronDown } from "lucide-react"
import { motion, AnimatePresence } from "framer-motion"
import { useClickOutside } from "../../hooks"
import { cn } from "../../../lib"

const CurrencySelector = ({ currencies, currency, onChange, additionalClasses = "" }) => {
  const selected = currencies.find((item) => item.code === currency)
  const [isOpen, setIsOpen] = useState(false)
  const dropdownRef = useRef(null)

  useClickOutside(dropdownRef, () => setIsOpen(false))

  const handleChange = async (code) => {
    try {
      await onChange?.(code)
    } finally {
      setIsOpen(false)
    }
  }
  return (
    <div className={cn("flex items-center justify-center  right-0 -bottom-9", additionalClasses)}>
      <div className="relative" ref={dropdownRef}>
        <button
          onClick={() => setIsOpen(!isOpen)}
          className={cn(
            "flex justify-between gap-2 px-1.5 py-1.5 text-second-success bg-surface-main font-medium rounded-button shadow-md transition-colors duration-200 cursor-pointer text-xs border-1 border-app-content-faint/20 w-[67px]"
          )}
        >
          <span>{selected?.symbol}</span>
          <span>{selected?.code}</span>
          <ChevronDown
            className={`w-4 h-4 transition-transform duration-200 ${isOpen ? "rotate-180" : ""}`}
          />
        </button>

        <AnimatePresence>
          {isOpen && (
            <motion.div
              initial={{ opacity: 0, y: -6, scale: 0.98 }}
              animate={{ opacity: 1, y: 0, scale: 1 }}
              exit={{ opacity: 0, y: -6, scale: 0.98 }}
              transition={{ duration: 0.18, ease: "easeOut" }}
              className="absolute top-full mt-2 w-full bg-surface-main rounded-card shadow-lg overflow-hidden border border-app-content-faint/10 z-50 flex items-center justify-center"
            >
              <div>
                {currencies.map((item) => {
                  const isActive = selected?.code === item.code
                  return (
                    <button
                      key={item.code}
                      onClick={() => handleChange(item.code)}
                      className={`w-full flex items-center gap-2 px-4 py-2.5 text-left transition-colors duration-150 text-xs cursor-pointer ${
                        isActive ? "text-second-success" : "text-text-main hover:bg-bg-secondary"
                      }`}
                    >
                      <span>{item.symbol}</span>
                      <span className="font-medium">{item.code}</span>
                    </button>
                  )
                })}
              </div>
            </motion.div>
          )}
        </AnimatePresence>
      </div>
    </div>
  )
}

export default CurrencySelector
